import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider, useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store';
import App from './App';
import { fcmManager } from './fcmManager';
import ConfirmModal from './components/layout/ConfirmModal';
import useConfirm from './hooks/useConfirm';
import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import reportWebVitals from './reportWebVitals';

function ConfirmAndAlertInjector({ children }) {
  const confirm = useConfirm();                // <-- usa useConfirm

  React.useEffect(() => {
    // la funzione che passa a FcmManager
    fcmManager.setPromptFunction(({ title, message }) =>
      confirm({ title, message })
    );
  }, [confirm]);

  return (
    <>
      {children}
      <ConfirmModal />
      <ToastContainer
        position="bottom-center"
        autoClose={4000}
        hideProgressBar
        newestOnTop
        pauseOnHover
        toastClassName="toast-alert"
        bodyClassName="toast-alert-body"
        progressClassName="toast-alert-progress"
        // theme="colored"
        transition={Zoom}
      />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
          <ConfirmAndAlertInjector>
            <App />
          </ConfirmAndAlertInjector>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// Registra il Service Worker per Firebase Messaging
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('SW registrato con successo:', registration);
      
      // RIMOSSO: Non serve più inizializzare Firebase nel SW
      // activeWorker.postMessage({ type: 'INITIALIZE_FIREBASE' });
      
    } catch (error) {
      console.error('Errore registrazione SW:', error);
    }
  });
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();